<template>
	<div
		id="listArea"
		ref="listArea"
		:style="{transform: `translate3d(0px, ${refresh.distance/3}px, 0px)`}"
		@touchstart="touchStart"
		@touchmove="touchMove"
		@touchend="touchEnd"
	>
		<div class="load-more-info">
			<p class="text">{{refresh.distance >= legalDistance ? '释放更新' : '下拉刷新'}}</p>
		</div>
		<div class="media-area" id="2" v-html="mediaContent"></div>
		<ul class="news-list">
			<NewsItem v-for="(item,index) in listData" :key="index" :data="item" />
		</ul>
		<infinite-loading spinner="circles" :identifier="identifierId" @infinite="infiniteHandler">
			<div slot="no-more">没有更多了</div>
			<div slot="no-results">暂无数据</div>
		</infinite-loading>
	</div>
</template>
<script>
	import API from "../api.js";
	import InfiniteLoading from "vue-infinite-loading";
	import NewsItem from "../components/NewsItem";

	export default {
		name: "DataList",
		components: {
			NewsItem,
			InfiniteLoading,
		},
		props: {
			cid: {
				required: true,
				type: Number,
			},
		},
		data() {
			return {
				newsIndex: 0,
				listData: [],
				identifierId: "r" + (this.$route.params.channel || this.cid),
				refresh: {
					start: 0,
					distance: 0,
					canRefresh: true,
				},
				legalDistance: 200,
				storeData: {},
				mediaObj: window.afocus_adv,
				mediaContent: "",
			};
		},
		methods: {
			async infiniteHandler($state) {
				let { newsIndex } = this;
				let cid = +(this.$route.params.channel || this.cid);
				let newsData = await API.getNewsList(cid, newsIndex);
				if (newsData.length) {
					this.listData.push(...newsData);
					this.newsIndex += 10;
					$state.loaded();
				} else {
					$state.complete();
				}
				this.storeData[cid] = {
					listData: this.listData,
					newsIndex: this.newsIndex,
				};
			},
			touchStart(e) {
				let { canRefresh } = this.refresh;
				this.refresh.canRefresh = document.documentElement.scrollTop === 0;
				if (!canRefresh) return;
				this.refresh.start = e.targetTouches[0].clientY;
			},
			touchMove(e) {
				let { start, canRefresh } = this.refresh;
				let distance = e.targetTouches[0].clientY - start;
				if (!canRefresh || distance <= 0) return;
				e.preventDefault();
				this.refresh.distance = distance;
			},
			touchEnd() {
				this.$parent.pageTop = document.documentElement.scrollTop;
				let { canRefresh, distance } = this.refresh;
				if (!canRefresh || distance < this.legalDistance) {
					this.refresh.distance = 0;
					return;
				}
				this.refresh.distance = 0;
				this.listData = [];
				this.newsIndex = 0;
				this.identifierId += 1;
			},
			show(id) {
				var self = this;
				var afocus_content = this.mediaObj[id];
				var afocus_type = afocus_content.type;
				var afocus_array = afocus_content.material;
				var img_dom = "";
				if (afocus_type == 1) {
					for (var i = 0; i < afocus_array.length; i++) {
						if(afocus_array[i].url!=""){
							img_dom += '<a href="' + afocus_array[i].url + '" target="_blank">';
						}else{
							img_dom += '<a>';
						}
						img_dom += '<img src="' + afocus_array[i].images + '" width="100%" height="auto" border="0"/></a>';
					}
					if (afocus_array.length > 1) {
						setTimeout(function(){
							self.changeImg(id, afocus_array,afocus_content.scrollTime);
						},10)
					}
					return img_dom;
				}
			},
			changeImg(id, advArray,scrollTime) {
				var pDom = document.getElementById(id),
					cDom = pDom.querySelectorAll('a'),
					flag = 0; /*flag为0时第一张图显示*/
				function aryfor() {
					for (var i = 0; i < cDom.length; i++) {
						if (i == flag) {
							cDom[i].style.display = 'block'
						} else {
							cDom[i].style.display = 'none'
						}
					}
				}
				aryfor()
				setInterval(function () {
					flag++
					if (flag == advArray.length) flag = 0
					aryfor()
				}, scrollTime*1000)
			},
		},
		watch: {
			$route() {
				let { storeData } = this;
				let cid = +(this.$route.params.channel || this.cid);
				if (storeData[cid]) {
					this.listData = storeData[cid].listData;
					this.newsIndex = storeData[cid].newsIndex;
					this.$nextTick(() => {
						document.documentElement.scrollTop = this.$parent.scrollTop[
							cid
						];
					});
				} else {
					this.listData = [];
					this.newsIndex = 0;
					this.identifierId = "r" + this.$route.params.channel;
				}
			},
		},
		computed: {
			paddingDistance() {
				return this.refresh.distance / 3.5 + 90;
			},
		},
		created() {
			this.mediaContent = this.show(2);
		}
	};
</script>
<style lang="scss">
	#listArea {
		position: relative;
		padding: 90px 10px 10px;
	}
	.infinite-loading-container,
	.text {
		color: #999;
	}
	.load-more-info {
		position: absolute;
		top: 45px;
		left: 0;
		width: 100%;
		text-align: center;
	}
	.media-area {
		img {
			display: block;
			width: 100%;
			height: auto;
			margin-bottom: 10px;
		}
	}
</style>